const state = {
    declareStepStatus: sessionStorage.getItem("parkDeclareStepStatus") || "1",
    nowStepStatus: sessionStorage.getItem("parkNowStepStatus") || "1",
    stepId: sessionStorage.getItem("parkStepId") || null
};

const mutations = {
    SET_DECLARE_STEP_STATUS: (state, declareStepStatus) => {
        state.declareStepStatus = declareStepStatus;
        sessionStorage.setItem("parkDeclareStepStatus", declareStepStatus);
    },
    SET_NOW_STEP_STATUS: (state, nowStepStatus) => {
        state.nowStepStatus = nowStepStatus;
        sessionStorage.setItem("parkNowStepStatus", nowStepStatus);
    },
    SET_STEP_ID: (state, stepId) => {
        state.stepId = stepId;
        sessionStorage.setItem("parkStepId", stepId);
    }
};

const actions = {
    setDeclareStepStatus({ commit }, declareStepStatus) {
        commit("SET_DECLARE_STEP_STATUS", declareStepStatus);
    },
    setNowStepStatus({ commit }, nowStepStatus) {
        commit("SET_NOW_STEP_STATUS", nowStepStatus);
    },
    setStepId({ commit }, stepId) {
        commit("SET_STEP_ID", stepId);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
